import type { ApiSchema } from "../../../api/apiSchema";

/** What a person typed for a tool's inputs, as the values a tool run sends, or why it can't run yet. */
export type ToolRunValues =
  | { readonly kind: "ready"; readonly values: Readonly<Record<string, unknown>> }
  | { readonly kind: "missing"; readonly input: string }
  | { readonly kind: "invalid"; readonly input: string };

/**
 * The tool's inputs as values: plain text for an input that accepts `text`, JSON for any
 * other kind; an empty optional input is left out. The server checks each value's kind.
 */
export function toolInputValues(declared: Readonly<Record<string, ApiSchema<"ToolInput">>>, typed: Readonly<Record<string, string>>): ToolRunValues {
  const values: Record<string, unknown> = {};
  for (const [name, input] of Object.entries(declared)) {
    const text = typed[name] ?? "";
    if (text.trim() === "") {
      if (input.required) return { kind: "missing", input: name };
      continue;
    }
    if (input.accepts.includes("text")) {
      values[name] = text;
      continue;
    }
    try {
      values[name] = JSON.parse(text) as unknown;
    } catch {
      return { kind: "invalid", input: name };
    }
  }
  return { kind: "ready", values };
}
